exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#urlsDiv,#websitesDiv{max-height:450px;overflow:auto}#websitesDiv img{width:42px;height:42px;margin-right:5px}#websitesDiv .v-input__slot{margin-bottom:0}#websitesDiv .v-card__text{padding:12px}.v-input--selection-controls{margin-top:0!important;padding-top:0!important}.v-card{text-align:left}.url-link{text-decoration:none}.source-logo-fider{float:left;width:22px;height:22px;margin-right:10px}", ""]);

// exports
